import { AppErrorReason } from "~errors/errors";

export function createError(reason: AppErrorReason, context: string): Error {
    if (process.env.NODE_ENV === "development") {
        return new Error(`${reason}: ${context}`);
    }

    return new Error(`${reason}: ${context}`);
}

export const ANIMATED_GIF = /-999x-999/;
